import { createLucideIcon } from 'lucide-react';
export const CsvIcon = createLucideIcon('csv-icon', [
  [
    'path',
    {
      d: 'M12 16L10 14.5',
      key: '1ndn21',
    },
  ],
  [
    'path',
    {
      d: 'M12 16L14 14.5',
      key: 'z6x7hg',
    },
  ],
  [
    'path',
    {
      d: 'M12 16V10',
      key: 'kns5fo',
    },
  ],
  [
    'path',
    {
      d: 'M14.5 3H5V21H19V7.5L14.5 3Z',
      key: '18re6z',
    },
  ],
  [
    'path',
    {
      d: 'M15 18H9',
      key: '1lyqi6',
    },
  ],
  [
    'path',
    {
      d: 'M18.5 7.5H14V3.5',
      key: '11grls',
    },
  ],
]);
